/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import { Tab, Tabs } from "@heroui/tabs";
import React, { useState } from "react";
import Image from "next/image";
import { Link } from "@heroui/link";

import TyreSizeFilter from "@/components/element/CategoryTabbedFilter/categorySpecificFilter/tyres/TyreSizeFilter";
import MakeModelFilter from "@/components/element/CategoryTabbedFilter/MakeModelFilter";

interface HomePageHeroNavProps {
  csrfToken: string;
  tabbedNavLinks: {
    title: string;
    link: string;
    icon: any;
    id: number;
  }[];
}

const HomePageHeroNav: React.FC<HomePageHeroNavProps> = ({
  csrfToken,
  tabbedNavLinks,
}) => {
  const [selectedTab, setSelectedTab] = useState<any>("shop-tyres");

  return (
    <div className="flex flex-col w-full">
      <Tabs
        aria-label="Homepage Hero Navigation Tabs"
        classNames={{
          base: "w-full mx-auto",
          tabList: "w-full bg-transparent p-0 gap-2 md:gap-3 lg:gap-5",
          tab: "text-base md:text-xl lg:text-2xl font-medium md:font-semibold text-[#0F0F0F]/60 p-4 h-auto bg-[#F2F2F2] data-[selected=true]:bg-transparent data-[hover-unselected=true]:opacity-90",
          tabContent: "group-data-[selected=true]:text-white",
          cursor: "bg-ax-secondary",
          panel: `p-0 flex flex-col w-full bg-white relative ${selectedTab === "shop-tyres" ? "p-5 md:px-8 md:py-5" : "px-0 py-3"}`,
        }}
        radius="none"
        selectedKey={selectedTab}
        onSelectionChange={setSelectedTab}
      >
        <Tab key="shop-tyres" title="Shop Tyres">
          <Tabs
            classNames={{
              base: "mx-auto border-1 border-[#DCDCDC]",
              tabList: "w-full p-0 bg-[#F2F2F2]",
              tab: "text-base py-2 px-5 text-[#0F0F0F]/60 h-auto data-[hover-unselected=true]:opacity-90 data-[selected=true]:bg-transparent",
              tabContent: "group-data-[selected=true]:text-white",
              cursor: "bg-ax-secondary",
              panel:
                "p-0 flex flex-col w-full bg-white relative p-5 md:px-8 md:py-5",
            }}
            radius="none"
            variant="solid"
          >
            <Tab key="tyre-size-filter" title="By Tyre Size">
              <TyreSizeFilter
                isSingleColumn
                csrfToken={csrfToken}
                redirectUrl="/estore/tyres"
              />
            </Tab>
            <Tab key="tyre-make-model" title="By Vehicle">
              <MakeModelFilter
                isSingleColumn
                csrfToken={csrfToken}
                redirectUrl="/estore/tyres"
              />
            </Tab>
          </Tabs>
        </Tab>
        <Tab key="site-nav" title="Shop Services">
          {tabbedNavLinks.map((tabLink) => (
            <Link
              key={tabLink.id}
              className="group flex items-center justify-between gap-5 p-5 md:px-10 hover:!opacity-100  text-black/60 hover:bg-ax-secondary hover:font-medium hover:text-white text-xl md:text-2xl"
              href={tabLink.link}
            >
              <div className="flex items-center justify-start gap-4 md:gap-6">
                <Image
                  alt={tabLink.icon.title}
                  className="group-hover:invert-100 w-6 h-6 md:w-7 md:h-7 object-contain"
                  height={30}
                  src={tabLink.icon.meta.download_url}
                  width={30}
                />
                <p>{tabLink.title}</p>
              </div>
              <Image
                alt="Arrow"
                className="group-hover:invert-100 w-4 h-4 md:w-5 md:h-5 -rotate-90 object-contain"
                height={30}
                src="/icons/arrow_down_black.svg"
                width={30}
              />
            </Link>
          ))}
        </Tab>
      </Tabs>
    </div>
  );
};

export default HomePageHeroNav;
